import { memberMocks } from 'test/mock/memberMock';
import { tierMocks } from 'test/mock/tierMock';

type TierKeys = keyof typeof tierMocks;
type MemberKeys = keyof typeof memberMocks;

export function getMemberMockByTier(tier: string) {
  const key = tier as MemberKeys;
  const mock = memberMocks[key];

  return mock ?? memberMocks.voebiz;
}

export function getTierMockByTier(tier: string) {
  const key = tier as TierKeys;
  const mock = tierMocks[key];

  return mock ?? tierMocks.voebiz;
}
